import React from 'react';
import { useTranslation } from 'react-i18next';
import { Routes, Route, Navigate } from 'react-router-dom';
import MesApprobationsPage from './MesApprobationsPage';
import WorkflowsActifsPage from './WorkflowsActifsPage';
import CreerWorkflowPage from './CreerWorkflowPage';
import ChaineApprobationPage from './ChaineApprobationPage';
import StatutsApprobationsPage from './StatutsApprobationsPage';
import ModelesApprobationPage from './ModelesApprobationPage';
import ApprobationsAnalysesPage from './ApprobationsAnalysesPage';
import ApprobationsConfigPage from './ApprobationsConfigPage';
import ApprovalsDashboardPage from './ApprovalsDashboardPage';

const ApprobationsMainPage = () => {
  const { t } = useTranslation();
  const p = (key, opts) => t(`modules.approbations.pages.approbationsMainPage.${key}`, opts);

  return (
    <div aria-label={p('title')}>
      <span className="sr-only">{p('subtitle')}</span>
      <Routes>
        <Route index element={<Navigate to="/approbations/dashboard" replace />} />
        <Route path="/" element={<Navigate to="/approbations/dashboard" replace />} />
        <Route path="/dashboard" element={<ApprovalsDashboardPage />} />
        <Route path="/mes-approbations" element={<MesApprobationsPage />} />
        <Route path="/workflows" element={<WorkflowsActifsPage />} />
        <Route path="/creer" element={<CreerWorkflowPage />} />
        <Route path="/chaine" element={<ChaineApprobationPage />} />
        <Route path="/statuts" element={<StatutsApprobationsPage />} />
        <Route path="/modeles" element={<ModelesApprobationPage />} />
        <Route path="/analyses-rapports" element={<ApprobationsAnalysesPage />} />
        <Route path="/config" element={<ApprobationsConfigPage />} />
        <Route path="/*" element={<Navigate to="/approbations/dashboard" replace />} />
      </Routes>
    </div>
  );
};

export default ApprobationsMainPage;
